<template>
<div class="titre-block-edit">
  <v-textarea
    label="Citation"
    v-model="obj.text"
    placeholder="Saisissez la citation"
     auto-grow
  />






</div>
</template>

<script>
import BlockMixin from "../BlockMixin";

export default {
  name: "citation-block-edit",
  components: {},
  mixins:[BlockMixin],
  computed:{
    /**
     *
     * @return {MetiersBlock}
     */
    obj(){
      return this.block;
    }
  }
}
</script>
